<template>
  <el-card>
    <template v-slot:header>
    <div class="clearfix">
        <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Length of SEs and TEs</span>
    </div>
    </template>
    <el-container>
      <el-main>
        <div id="vslength" style="width:100%;height:500px;"></div> 
      </el-main>
    </el-container>
  </el-card>
</template>
  
  <script>
  export default {
    props: {
      species: {
        type: String,
        required: true
      },
      tissue: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        chartData: [],
        url: "http://183.175.59.4/devenhancer/",// 后端接口地址
      };
    },
    mounted() {
      this.handleAnalysis();
    },
    methods: {
      handleAnalysis() {
        // 发送请求获取后端数据
        const params = { Species: this.species, Tissue: this.tissue };
        this.$axios.get(this.url + "telist" + "/", { params }).then((response) => {
            // 对数据进行处理
            const data = response.data;
            if (data && Array.isArray(data) && data.length > 0) {
              let isSuper0Lengths = [];
              let isSuper1Lengths = [];
              for (let item of data) {
                if (item['isSuper'] !== undefined && item['Start'] !== undefined && item['Stop'] !== undefined) {
                  const length = parseInt(item['Stop']) - parseInt(item['Start']) + 1; // 计算长度
                  if (item['isSuper'] === '0') {
                    isSuper0Lengths.push(length);
                  } else if (item['isSuper'] === '1') {
                    isSuper1Lengths.push(length);
                  }
                }
              }
              // 计算中位数
              const isSuper0Median = this.calculateMedian(isSuper0Lengths);
              const isSuper1Median = this.calculateMedian(isSuper1Lengths);
            // 绘制柱状图
          const chart = this.$echarts.init(document.getElementById('vslength'));
          chart.setOption({
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: ['TEs', 'SEs']
            },
            yAxis: {
              type: 'value',
              name: 'Length/bp',
            },
            series: [{
              data: [isSuper0Median, isSuper1Median],
              type: 'bar',
              itemStyle: {
                normal: {
                  color: 'rgba(226, 197, 79, 0.8)' // 修改为带透明度的颜色
                }
              },
              label: {
                  show: true, // 展示柱子上方的数值
                  position: 'top',
                  color: '#333' // 修改数值文字颜色为黑色
              }
            }]
          });
            } else {
              this.$message.warning('No data found.');
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('Failed to fetch data.');
          });
        },
        calculateMedian(arr) {
          // 排序
          arr.sort((a, b) => a - b);
          // 计算中位数
          const len = arr.length;
          if (len % 2 === 0) {
            return Math.floor((arr[len / 2 - 1] + arr[len / 2]) / 2); // 向下取整
          } else {
            return arr[Math.floor(len / 2)];
          }
        }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/teAnalysis/Vslength.vue